import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CartToastService, CartToastData } from '../../services/cart-toast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cart-toast',
  standalone: true,
  imports: [CommonModule, RouterModule],
  styles: [`
    @keyframes toast-timer {
      from { width: 100%; }
      to   { width: 0%;   }
    }
    .timer-bar {
      animation: toast-timer 4s linear forwards;
    }
  `],
  template: `
    <div *ngIf="visible"
         class="fixed top-5 right-5 z-[99998] w-[320px] max-w-[calc(100vw-24px)]
                bg-white border-4 border-[var(--black)] rounded-2xl shadow-2xl
                transition-all duration-300 overflow-hidden"
         [class.opacity-0]="!entering"
         [class.translate-y-0]="entering"
         [class.-translate-y-2]="!entering"
         style="transform-origin: top right;">

      <!-- Timer bar -->
      <div class="h-1.5 bg-[var(--light-grey)] rounded-t-xl overflow-hidden">
        <div [attr.key]="timerKey" class="timer-bar h-full bg-[var(--secondary)] rounded-t-xl origin-left"></div>
      </div>

      <div class="px-4 pt-3 pb-4">
        <!-- Header row -->
        <div class="flex items-start justify-between gap-2 mb-2">
          <div class="flex items-center gap-2">
            <span class="w-5 h-5 rounded-full bg-[var(--secondary)] flex items-center justify-center flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 20 20" fill="white">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
            </span>
            <p class="text-[12px] uppercase font-bold tracking-widest text-[var(--dark-grey)]">Agregado al carrito</p>
          </div>
          <button (click)="dismiss()"
            class="text-[var(--grey)] hover:text-[var(--black)] transition-colors text-lg leading-none font-light flex-shrink-0 mt-0.5">
            ✕
          </button>
        </div>

        <!-- Item info -->
        <p class="font-bold text-[15px] text-[var(--black)] leading-tight">{{ toast?.title }}</p>
        <p *ngIf="toast?.subtitle" class="text-[12px] text-[var(--dark-grey)] mt-0.5 leading-snug">{{ toast?.subtitle }}</p>

        <!-- CTA -->
        <a routerLink="/cart" (click)="dismiss()"
           class="mt-3 flex items-center justify-center gap-2 w-full py-2 rounded-xl
                  bg-[var(--black)] text-white text-[12px] font-bold uppercase tracking-wide
                  hover:opacity-80 transition-opacity">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 576 512" fill="white">
            <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
          </svg>
          Ver carrito
        </a>
      </div>
    </div>
  `
})
export class CartToastComponent implements OnInit, OnDestroy {
  visible = false;
  entering = false;
  toast: CartToastData | null = null;
  timerKey = 0;

  private sub?: Subscription;
  private dismissTimer?: ReturnType<typeof setTimeout>;

  constructor(private cartToastService: CartToastService) {}

  ngOnInit() {
    this.sub = this.cartToastService.toast$.subscribe(data => {
      this.show(data);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    if (this.dismissTimer) clearTimeout(this.dismissTimer);
  }

  show(data: CartToastData) {
    if (this.dismissTimer) clearTimeout(this.dismissTimer);

    this.toast = data;
    this.visible = false;   // fuerza recreación del DOM
    this.entering = false;
    this.timerKey++;        // cambia la key → Angular recrea el timer-bar → reinicia la animación

    setTimeout(() => {
      this.visible = true;
      setTimeout(() => { this.entering = true; }, 10);
    }, 10);

    this.dismissTimer = setTimeout(() => this.dismiss(), 4000);
  }

  dismiss() {
    this.entering = false;
    setTimeout(() => { this.visible = false; }, 300);
  }
}

